import formatCountryToLanguage from './formatCountryToLanguage'

const allCountries = [
  'GB',
  'DK',
  'FI',
  'FR',
  'DE',
  'IT',
  'LV',
  'RU',
  'ES',
  'SE',
  'TR',
  'CZ',
  'NO',
  'EE',
  'NL',
  'PL',
  'US',
  'SK',
  'SI'
]

const allLanguages = allCountries.map(formatCountryToLanguage).flat(1)

export default (url, langcode) => {
  const arr = url.split('/')
  if (langcode === 'en') {
    if (allLanguages.includes(arr[1].replace('?lang=en',''))) {
      arr.splice(1, 1)
      return arr.join('/')
    }
    return arr.join('/')
  }
  if (allLanguages.includes(url.split('/')[1].toLowerCase())) {
    arr[1] = langcode
    return arr.join('/')
  }

  arr.splice(1, 0, langcode)
  return arr.join('/')
}
